import React, { useEffect } from 'react'
import PostLogin from '../../layout/postLogin'
import ManageKeywordNotesTypeSubType from './components/manageKeywordNotesTypeSubType'
import KeywordCount from './components/keywordCount'
import KeywordNotesTypeSubTypeCount from './components/keywordNotesTypeSubTypeCount'
import ManageSubKeywords from './components/manageSubKeywords'
import SubKeywordCount from './components/subKeywordCount'
import CopyKeywordMapping from './components/copyKeywordMapping'
import { NAME_KEYWORD_MANAGEMENT } from '../../constants'
import { Wrapper } from './style'

const KeywordManagement = () => {
  useEffect(() => {
    document.title = NAME_KEYWORD_MANAGEMENT
  }, [])

  return (
    <PostLogin pageTitle={NAME_KEYWORD_MANAGEMENT}>
      <Wrapper>
        <ManageKeywordNotesTypeSubType />
        <KeywordCount />
        <KeywordNotesTypeSubTypeCount />
        <ManageSubKeywords />
        <SubKeywordCount />
        <CopyKeywordMapping />
      </Wrapper>
    </PostLogin>
  )
}

export default KeywordManagement
